import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  SlidersHorizontal,
  X,
  ChevronRight,
  Tag,
  Star,
  Zap,
  ShieldCheck,
  TrendingUp,
} from "lucide-react";
import ProductCard from "../../components/common/ProductCard";
import { productService } from "../../services/product.service";
import "./ShopPage.css";

/* ── Custom SVG category icons ── */
const IconAllProducts = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1"
      y="1"
      width="6.5"
      height="6.5"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="10.5"
      y="1"
      width="6.5"
      height="6.5"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="1"
      y="10.5"
      width="6.5"
      height="6.5"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <rect
      x="10.5"
      y="10.5"
      width="6.5"
      height="6.5"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);

const IconBattery = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.5"
      y="4.5"
      width="13"
      height="9"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M14.5 7v4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M16.5 7.5v3"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M4.5 9h4M8.5 7l-1.5 2h3L8.5 11"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconLiFePO4 = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="1.5"
      y="4.5"
      width="13"
      height="9"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M16.5 7.5v3"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M14.5 7v4"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.5 9.5h4.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M4.5 7.5h4.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M4.5 11.5h4.5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

const IconScooty = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="3.5" cy="13" r="2.2" stroke="currentColor" strokeWidth="1.4" />
    <circle cx="14.5" cy="13" r="2.2" stroke="currentColor" strokeWidth="1.4" />
    <path
      d="M5.7 13H12.3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M10 13L9 8.5H6.5L5.7 13"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 8.5L12 7H14.5V9.5L12.3 13"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 6.5h2"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

const IconInverter = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="2"
      y="5"
      width="14"
      height="8"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M5 9l2-2 2 4 2-4 2 2"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="14.5" cy="7.5" r="0.8" fill="currentColor" />
    <path
      d="M7 3v2M11 3v2"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>
);

const IconBike = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="3.5" cy="13" r="2.3" stroke="currentColor" strokeWidth="1.4" />
    <circle cx="14.5" cy="13" r="2.3" stroke="currentColor" strokeWidth="1.4" />
    <path
      d="M6 13L9 7l3 6"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 7h3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M9 7l-1-2h2.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13l2.5-3"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <path
      d="M6 13L3.5 10.5"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>
);

const IconCar = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 11.5h13v2.5a.5.5 0 01-.5.5H3a.5.5 0 01-.5-.5v-2.5z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 11.5l2-5h9l2 5"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 11.5V9.5h7v2"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <circle cx="5" cy="13.5" r="1" fill="currentColor" />
    <circle cx="13" cy="13.5" r="1" fill="currentColor" />
    <path
      d="M6 6.5h6"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

/* NEW BMS ICON - Designed to look like a microchip/circuit board */
const IconBMS = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4"
      y="4"
      width="10"
      height="10"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M4 6H2M4 9H2M4 12H2M14 6H16M14 9H16M14 12H16M6 4V2M9 4V2M12 4V2M6 14V16M9 14V16M12 14V16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <circle cx="9" cy="9" r="1.5" fill="currentColor" />
  </svg>
);

const IconCharger = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M18 7V4a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v3" />
    <path d="M6 11h12" />
    <path d="M6 15h12" />
    <path d="M10 11v10" />
    <path d="M14 11v10" />
  </svg>
);

const CAT_ICONS = {
  all: <IconAllProducts />,
  "smart-li-ion-batteries": <IconBattery />,
  "smart-lithium-phosphate-battery": <IconLiFePO4 />,
  "scooty-batteries": <IconScooty />,
  "smart-integrated-inverters": <IconInverter />,
  "bike-batteries": <IconBike />,
  "car-batteries": <IconCar />,
  "bms": <IconBMS />, 
  "battery-chargers": <IconCharger />,
};

const ShopPage = ({
  onNavigate,
  onAddToCart,
  cartItems,
  onQuantityChange,
  onRemoveItem,
  favouriteItems,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const productSectionRef = useRef(null);

  const [allProducts, setAllProducts] = useState([]);
  const [displayedProducts, setDisplayedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [activeCategory, setActiveCategory] = useState("all");
  const [sortOption, setSortOption] = useState("featured");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const categories = [
    { name: "All Products", category_id: "all", tag: "Full Range" },
    {
      name: "Smart Li-Ion Batteries",
      category_id: "smart-li-ion-batteries",
      tag: "Bestseller",
    },
    {
      name: "Lithium Phosphate",
      category_id: "smart-lithium-phosphate-battery",
      tag: "Safe",
    },
    {
      name: "Scooty Batteries",
      category_id: "scooty-batteries",
      tag: "EV Ready",
    },
    {
      name: "Smart Integrated Inverters",
      category_id: "smart-integrated-inverters",
      tag: "Smart",
    },
    { name: "Bike Batteries", category_id: "bike-batteries", tag: "Power" },
    { name: "Car Batteries", category_id: "car-batteries", tag: "Heavy" },
    { name: "BMS Systems", category_id: "bms", tag: "Tech" },
    { name: "battery-chargers", category_id: "battery-chargers", tag: "Power" },
  ];

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        const data = await productService.getAllProducts();
        setAllProducts(data);
        setDisplayedProducts(data);
      } catch (err) {
        console.error(err);
        setError("Failed to load products. Please refresh.");
      } finally {
        setLoading(false);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const cat = params.get("category");
    if (cat) {
      setActiveCategory(cat);
      setTimeout(() => {
        productSectionRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 200);
    }
  }, [location.search]);

  useEffect(() => {
    let result = [...allProducts];
    if (activeCategory !== "all")
      result = result.filter((p) => p.category_id === activeCategory);
    if (minPrice !== "" || maxPrice !== "") {
      result = result.filter((p) => {
        const price = Number(p.price_display);
        if (isNaN(price)) return false;
        if (minPrice && price < Number(minPrice)) return false;
        if (maxPrice && price > Number(maxPrice)) return false;
        return true;
      });
    }
    if (sortOption === "low-high")
      result.sort((a, b) => Number(a.price_display) - Number(b.price_display));
    if (sortOption === "high-low")
      result.sort((a, b) => Number(b.price_display) - Number(a.price_display));
    setDisplayedProducts(result);
  }, [activeCategory, sortOption, minPrice, maxPrice, allProducts]);

  useEffect(() => {
    document.body.style.overflow = isSidebarOpen ? "hidden" : "unset";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isSidebarOpen]);

  const handleCategoryClick = (id) => {
    setActiveCategory(id);
    navigate(`/shop?category=${id}`);
    if (window.innerWidth <= 1024) setIsSidebarOpen(false);
  };

  const resetFilters = () => {
    setActiveCategory("all");
    setMinPrice("");
    setMaxPrice("");
    setSortOption("featured");
    navigate("/shop");
  };

  const isFilterActive =
    activeCategory !== "all" || minPrice !== "" || maxPrice !== "";
  const activeCategoryName = categories.find(
    (c) => c.category_id === activeCategory,
  )?.name;

  return (
    <div className="sp-wrap fade-in">
      {/* ── HERO ── */}
      <header className="sp-hero">
        <div className="sp-hero__dots" />
        <div className="sp-hero__inner">
          <div className="sp-hero__text">
            <div className="sp-hero__eyebrow">
              <Zap size={13} />
              Zynventics Power Systems
            </div>
            <h1 className="sp-hero__h1">
              Power Built
              <br />
              <em>For Tomorrow.</em>
            </h1>
            <p className="sp-hero__sub">
              Next-generation lithium batteries &amp; smart inverters —
              engineered for reliability, speed, and longevity.
            </p>
            <div className="sp-hero__pills">
              <span className="sp-hero__pill">
                <ShieldCheck size={13} /> 2-Year Warranty
              </span>
              <span className="sp-hero__pill">
                <TrendingUp size={13} /> 10,000+ Customers
              </span>
              <span className="sp-hero__pill">
                <Star size={13} fill="currentColor" /> 4.9 Rated
              </span>
            </div>
          </div>

          <div className="sp-hero__stats">
            <div className="sp-hero__stat">
              <span className="sp-hero__stat-n">500+</span>
              <span className="sp-hero__stat-l">Products</span>
            </div>
            <div className="sp-hero__stat sp-hero__stat--hi">
              <span className="sp-hero__stat-n">30%</span>
              <span className="sp-hero__stat-l">Sale On Now</span>
            </div>
            <div className="sp-hero__stat">
              <span className="sp-hero__stat-n">48hr</span>
              <span className="sp-hero__stat-l">Dispatch</span>
            </div>
          </div>
        </div>
      </header>

      {/* ── BODY ── */}
      <div className="sp-body">
        {isSidebarOpen && (
          <div
            className="sp-overlay"
            onClick={() => setIsSidebarOpen(false)}
            aria-hidden="true"
          />
        )}

        {/* SIDEBAR */}
        <aside className={`sp-sidebar ${isSidebarOpen ? "is-open" : ""}`}>
          <div className="sp-sidebar__inner">
            <div className="sp-sidebar__head">
              <div>
                <p className="sp-sb-eyebrow">Filter</p>
                <h2 className="sp-sb-title">Refine</h2>
              </div>
              <div className="sp-sb-actions">
                <button onClick={resetFilters} className="sp-clear-btn">
                  Reset all
                </button>
                <button
                  className="sp-close-btn"
                  onClick={() => setIsSidebarOpen(false)}
                >
                  <X size={17} />
                </button>
              </div>
            </div>

            <div className="sp-filter-group">
              <p className="sp-filter-lbl">Categories</p>
              <ul className="sp-cat-list">
                {categories.map((cat) => (
                  <li
                    key={cat.category_id}
                    className={`sp-cat-item ${activeCategory === cat.category_id ? "is-active" : ""}`}
                    onClick={() => handleCategoryClick(cat.category_id)}
                  >
                    <span className="sp-cat-ic">
                      {CAT_ICONS[cat.category_id]}
                    </span>
                    <span className="sp-cat-nm">{cat.name}</span>
                    <span
                      className={`sp-cat-tag ${activeCategory === cat.category_id ? "is-active" : ""}`}
                    >
                      {cat.tag}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="sp-filter-group">
              <p className="sp-filter-lbl">Price Range</p>
              <div className="sp-price-row">
                <div className="sp-price-field">
                  <span className="sp-price-sym">₹</span>
                  <input
                    type="number"
                    placeholder="Min"
                    value={minPrice}
                    onChange={(e) => setMinPrice(e.target.value)}
                  />
                </div>
                <span className="sp-price-dash">—</span>
                <div className="sp-price-field">
                  <span className="sp-price-sym">₹</span>
                  <input
                    type="number"
                    placeholder="Max"
                    value={maxPrice}
                    onChange={(e) => setMaxPrice(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Promo */}
            <div className="sp-promo">
              <div className="sp-promo__wm">OFFER</div>
              <span className="sp-promo__badge">Limited Time</span>
              <h3 className="sp-promo__title">Zynvert Pro</h3>
              <p className="sp-promo__desc">
                Get <strong>20% off</strong> your first premium battery.
              </p>
              <button className="sp-promo__btn">
                Claim Offer <ChevronRight size={14} />
              </button>
            </div>
          </div>
        </aside>

        {/* MAIN */}
        <main className="sp-main" ref={productSectionRef}>
          <nav className="sp-breadcrumb">
            <span onClick={resetFilters} className="sp-bc-home">
              Shop
            </span>
            {activeCategory !== "all" && (
              <>
                <span className="sp-bc-sep">/</span>
                <span className="sp-bc-curr">{activeCategoryName}</span>
              </>
            )}
          </nav>

          <div className="sp-toolbar">
            <button
              className={`sp-mob-btn ${isFilterActive ? "has-badge" : ""}`}
              onClick={() => setIsSidebarOpen(true)}
            >
              <SlidersHorizontal size={16} />
              Filters
              {isFilterActive && <span className="sp-badge-dot" />}
            </button>
            <div className="sp-toolbar__right">
              <span className="sp-count">
                <strong>{displayedProducts.length}</strong> products found
              </span>
              <div className="sp-sort">
                <label htmlFor="sp-sort-sel">Sort by</label>
                <select
                  id="sp-sort-sel"
                  value={sortOption}
                  onChange={(e) => setSortOption(e.target.value)}
                >
                  <option value="featured">Featured</option>
                  <option value="low-high">Price: Low → High</option>
                  <option value="high-low">Price: High → Low</option>
                </select>
              </div>
            </div>
          </div>

          {activeCategory !== "all" && (
            <div className="sp-active-pill">
              <span>{activeCategoryName}</span>
              <button className="sp-pill-x" onClick={resetFilters}>
                <X size={12} />
              </button>
            </div>
          )}

          {loading ? (
            <div className="sp-state">
              <div className="sp-loader">
                <div />
                <div />
                <div />
              </div>
              <p>Loading Zynvert catalog…</p>
            </div>
          ) : error ? (
            <div className="sp-state">
              <p className="sp-err">{error}</p>
            </div>
          ) : displayedProducts.length === 0 ? (
            <div className="sp-state sp-empty">
              <div className="sp-empty__ico">
                <Tag size={26} />
              </div>
              <h3>No products found</h3>
              <p>Try adjusting your category or price filters.</p>
              <button onClick={resetFilters} className="sp-empty__btn">
                Clear Filters
              </button>
            </div>
          ) : (
            <div className="sp-grid">
              {displayedProducts.map((product, i) => (
                <div
                  key={product._id || product.product_id}
                  className="sp-card-wrap"
                  style={{ animationDelay: `${i * 35}ms` }}
                >
                  <ProductCard
                    product={product}
                    productId={product.product_id || product._id}
                    onNavigate={onNavigate}
                    onAddToCart={onAddToCart}
                    cartItems={cartItems}
                    onQuantityChange={onQuantityChange}
                    onRemoveItem={onRemoveItem}
                    favouriteItems={favouriteItems}
                  />
                </div>
              ))}
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default ShopPage;